import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {

}
export class HiddenFieldComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
  
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  onTextEditChange = (e) => {
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;
  
    FormValidationUtils.validateText(field);


    this.props.callbackElement(getRootComponent(field));
  }
  
  onBlur=(e)=>{
    let field = this.props.field;
    FormValidationUtils.evalRegularExpression(field)

    if(field.Valid){
      FormValidationUtils.runJavascript(field);
    }
      

    this.props.callbackElement(getRootComponent(field));
  }

  render() {
    let field = this.props.field;
    let displayfield: boolean = true;
   
    if(!field.Visible) return null;

    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;

    let foundFilterFields: FormSectionElements[];
    let foundFilterField: FormSectionElements;

    let isCounterDisplay = this.props.field.counterVisible;

    let lengthAndRow = this.props.field.Length;
    let numOfRow = 5;
    let maxLength = 500;

    if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
      let arr = lengthAndRow.split(",");
      numOfRow = parseInt(arr[0].toString(), 10);
      maxLength = parseInt(arr[1].toString(), 10);
    } else if (lengthAndRow) {
      maxLength = parseInt(lengthAndRow);
    }

    if (this.props.field.FilterField != null) {
      let filterValue;
      let baseName;
      let bindName;
      let parts = this.props.field.FilterField.split('.');
      if (parts.length == 3) {
        baseName = parts[0] + '.' + parts[1];
        bindName = parts[2];
      }
      if (parts.length == 2) {
        baseName = parts[0];
        bindName = parts[1];
      }
      if (parts.length == 1) {
        baseName = '';
        bindName = parts[0];
      }

      foundFilterField = XMLParser.findSectionElement(this.props.field, bindName);

      if (foundFilterField != null) {
        filterValue = foundFilterField.Value;

        if ((foundFilterField != null && (filterValue == null || filterValue == '')) || filterValue != null && (this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1)) {
          displayfield = false;
        }
      } else {
        displayfield = true;
      }


      if (this.props.field.FilterCompareMethod != null && this.props.field.FilterCompareMethod != '' && foundFilterField != null && foundFilterField.Datatype == 'Date') {
        if (foundFilterField.Value) {
          let otherDate = new Date(foundFilterField.Value);
          let today = new Date();
          var diff = otherDate.getTime() - today.getTime();
          var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
          if (this.props.field.FilterCompareMethod == 'greater')
            displayfield = diffDays <= Number.parseInt(this.props.field.FilterValue);
          else
            displayfield = diffDays >= Number.parseInt(this.props.field.FilterValue);
        } else {
          displayfield = false;
        }
      }

    }

    this.props.field.Visible = displayfield;
    if (displayfield) {
if(field.Value==null) 
  field.Value="";
        const validClass = field.Length?'ontario-input' +  " " + field.Length: 'ontario-input';
        const invalidClass = field.Length?'ontario-input' +  " " + field.Length + ' ontario-input__error' :'ontario-input ontario-input__error';
      
        controlArray.push(
          <div key={'div_hidden_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>      
            <input style={{display:field.Visible?'block':'none'}} 
              type="hidden"
              id={field.LoadBindName} 
              key={'fdIpt_' + this.props.field.Id}
              value={field.Value}>
            </input>
          </div>
        );
      } 
    

    return controlArray;
  }
}